import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import LinkButton from '../LinkButton';

export class Enquiry extends Component {
    static displayName = Enquiry.name;

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true };
        this.history = props.history;
    }

    componentDidMount() {
    }
    goto(page) {
        this.history.push(page);
    }

    render() {
        return <div className="container" >
            <h3>General Enquiries</h3>
            <div className="row mb-3 ">
                <LinkButton className="btn btn-primary col-12 mb-2" to="ProductEnquiry" >Product Enquiry</LinkButton>
                <LinkButton className="btn btn-primary col-12 mb-2" to="LocationEnquiry" >Location Enquiry</LinkButton>
            </div>            
        </div>
    }


}
